import React from "react";
import { ArrowUpRightIcon } from "lucide-react";
import { steps } from "../data/content";
import { eyebrow, h2, section, shell } from "../utils/styles";
export function Method() {
  return <section id="metodo" className="bg-moss-2" data-id="element-104" data-mp="c1gkewnva7pd">
      <div className={`${shell} ${section}`} data-id="element-105" data-mp="c2rlgopxh1cs">
        <div className="mb-7 sm:mb-[35px] sm:flex sm:items-end sm:justify-between sm:gap-[30px]" data-id="element-106" data-mp="h1l1ansot4g4">
          <div data-id="element-107" data-mp="3fj74ctrxufzx">
            <p className={eyebrow} data-id="element-108" data-mp="3fjglrsyx3eu0">El método</p>
            <h2 className={`${h2} mb-0`} data-id="element-109" data-mp="3fgm1q2jtfw14">Un paso a la vez, con una dirección clara</h2>
          </div>
          <p className="mt-5 max-w-[300px] text-xs leading-[1.75] text-muted sm:mb-[5px] sm:mt-0" data-id="element-110" data-mp="3kffe1rnd9gzp">
            De la idea a una oferta lista para vender, con acompañamiento en cada etapa.
          </p>
        </div>
        <ol className="grid grid-cols-1 gap-[9px] min-[351px]:grid-cols-2 sm:gap-3 md:grid-cols-3" data-id="element-111" data-mp="2ws78d8m105x5">
          {steps.map((s, i) => <li key={s.title} className="relative min-h-[214px] rounded-[10px] border border-line-strong bg-moss-3 px-4 py-5 sm:p-[26px]" data-id="element-112" data-mp="31q8slwv6uba7" data-mpi={i}>
              <small className="mb-[25px] block text-[11px] text-lime sm:mb-[30px]" data-id="element-113" data-mp="kftivt6t0iv6">
                {String(i + 1).padStart(2, "0")}
              </small>
              <ArrowUpRightIcon className="absolute right-[15px] top-[18px] h-4 w-4 text-[#91a779] sm:right-6 sm:top-[22px]" aria-hidden="true" data-id="element-114" data-mp="fnihelwf0p0i" />
              <h3 className="mb-2.5 font-display text-base font-semibold leading-[1.35] tracking-[-0.5px] sm:text-[19px]" data-id="element-115" data-mp="6q86j1nif1w4">
                {s.title}
              </h3>
              <p className="text-[11px] leading-[1.75] text-muted sm:text-xs" data-id="element-116" data-mp="3sx6cjprhvp9s">{s.description}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}